import { Card, Col, Empty, Row } from 'antd';
import ReactECharts from 'echarts-for-react';
import type { UploadStatsResponse } from '@/api/uploadRecords';
import { buildProjectOption, buildSourceOption, buildTimelineOption } from './uploadStatsConfig';
import { useT } from '@/i18n';

interface Props {
  data: UploadStatsResponse | null;
  chartReady: boolean;
}

const ChartBox = ({ option }: { option: Record<string, unknown> }) => (
  <div style={{ height: 320, width: '100%' }}>
    <ReactECharts
      option={option}
      style={{ height: '100%', width: '100%' }}
      opts={{ renderer: 'svg' }}
      notMerge
      lazyUpdate
    />
  </div>
);

const UploadStatsCharts = ({ data, chartReady }: Props) => {
  const { t } = useT();
  const hasData = Boolean(data && data.summary.total > 0);
  const empty = <Empty description={t('所选范围内暂无上传数据')} style={{ padding: 48 }} />;

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} lg={14}>
          <Card title={t('上传趋势')} style={{ borderRadius: 8 }}>
            {hasData && chartReady ? (
              <ChartBox option={buildTimelineOption(data!.timeline, t)} />
            ) : empty}
          </Card>
        </Col>
        <Col xs={24} lg={10}>
          <Card title={t('来源分布')} style={{ borderRadius: 8 }}>
            {hasData && chartReady ? (
              <ChartBox option={buildSourceOption(data!.by_source, t)} />
            ) : empty}
          </Card>
        </Col>
      </Row>
      <Card title={t('按项目分布（Top 15）')} style={{ borderRadius: 8, marginBottom: 16 }}>
        {hasData && chartReady ? (
          <ChartBox option={buildProjectOption(data!.by_project, t)} />
        ) : empty}
      </Card>
    </>
  );
};

export default UploadStatsCharts;
